import { render, staticRenderFns } from "./VisitorsFavorites.vue?vue&type=template&id=f8f3b4ca&scoped=true&"
import script from "./VisitorsFavorites.vue?vue&type=script&lang=js&"
export * from "./VisitorsFavorites.vue?vue&type=script&lang=js&"
import style0 from "./VisitorsFavorites.vue?vue&type=style&index=0&id=f8f3b4ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f3b4ca",
  null
  
)

export default component.exports